(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/matchlineup/assets/javascripts/models/statmatchlineup.js') >= 0) return;  svs.modules.push('/components/statistics/matchlineup/assets/javascripts/models/statmatchlineup.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs = svs || {};
  svs.statistics = svs.statistics || {};
  svs.statistics.models = svs.statistics.models || {};

  svs.statistics.models.statMatchLineup = Backbone.Model.extend(
    _.extend({}, svs.statistics.mixins.SocketSubscriber, {
      url: function() {
        return (
          svs.core.jupiter.url() +
          '/sport/1/matches/' +
          this.urlParams.id +
          '/lineups'
        );
      },

      defaults: function() {
        if (
          svs.utils.ns.isNamespace('svs.statistics.data.matchModels.lineups')
        ) {
          return svs.statistics.data.matchModels.lineups;
        }
      },

      initialize: function(options) {
        this.urlParams = options.urlParams;
        this.socketURL = '/sport/1/matches/' + this.urlParams.id + '/lineups';
        this.logger = new svs.core.log.Logger(
          'svs.statistics.models.statMatchLineup'
        );
      },

      hasTeams: function() {
        return (
          this.get('awayTeam') !== undefined &&
          this.get('homeTeam') !== undefined
        );
      },

      hasLineups: function() {
        if (!this.hasTeams()) {
          return false;
        }

        if (
          svs.utils.ns.isNamespace(
            'attributes.homeTeam.formation.formationMatrix',
            this
          )
        ) {
          if (this.attributes.homeTeam.formation.formationMatrix.length > 1) {
            return true;
          }
        }

        if (
          svs.utils.ns.isNamespace(
            'attributes.awayTeam.formation.formationMatrix',
            this
          )
        ) {
          if (this.attributes.awayTeam.formation.formationMatrix.length > 1) {
            return true;
          }
        }

        return false;
      },

      start: function() {
        this.subscribe(this.socketURL, this.onSocketUpdate, false);
      },

      stop: function() {
        this.unsubscribe();
      },

      onSocketUpdate: function(data) {
        if (!data) {
          this.logger.info('Invalid data on socket.', data);
          return;
        }

        if (data.homeTeam && data.awayTeam) {
          this.set(data); 
        }
      },

      sortStartersByPosition: function() {
        if (!this.hasTeams()) {
          return;
        }

        var homeTeamPlayers = this.get('homeTeam').players,
          awayTeamPlayers = this.get('awayTeam').players;

        _.each(
          awayTeamPlayers,
          function(group, name) {
            if (name === 'starters') {
              awayTeamPlayers[name] = this.sortPlayersByAttribute(
                group,
                'position'
              );
            }
          },
          this
        );

        _.each(
          homeTeamPlayers,
          function(group, name) {
            if (name === 'starters') {
              homeTeamPlayers[name] = this.sortPlayersByAttribute(
                group,
                'position'
              );
            }
          },
          this
        );
      },

      sortPlayersByAttribute: function(players, sortAttribute) {
        return _.sortBy(players, function(player) {
          return parseInt(player[sortAttribute], 10);
        });
      },

      getFormationByPosition: function(theme) {
        var homeTeam = this.get('homeTeam'),
          awayTeam = this.get('awayTeam'),
          formattedHomeTeamFormation,
          formattedAwayTeamFormation;

        if (homeTeam && homeTeam.formation) {
          formattedHomeTeamFormation = theme('getFormationByPosition', {
            formation: homeTeam.formation,
            players: homeTeam.players
          });
        }

        if (awayTeam && awayTeam.formation) {
          formattedAwayTeamFormation = theme('getFormationByPosition', {
            formation: awayTeam.formation,
            players: awayTeam.players
          });
        }

        return {
          formattedHomeTeamFormation: formattedHomeTeamFormation,
          formattedAwayTeamFormation: formattedAwayTeamFormation
        };
      }
    })
  );
})(Backbone, _, svs);

 })(window);